import type { PremiumClickContext } from './premiumAnalytics';
import type { premiumOffer } from '../pages/PremiumPage/offer';

/** Keep delivery alive across checkout navigation; never block or retry a click. */
export function recordPremiumUnlock(page: string, details: PremiumClickContext, offer: ReturnType<typeof premiumOffer>): void {
  try {
    void fetch('/api/analytics/events', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventName: 'premium_unlock_clicked_v2',
        context: {
          page, feature: details.feature ?? 'all', context: details.context ?? page,
          placement: details.placement, action: 'open_buy_page', theme: details.theme,
          target_tier: details.targetTier, current_tier: details.currentTier,
          purchase_type: details.purchaseType,
          ...(offer.ready ? {
            experiment: offer.experiment, variant: offer.variant, offer_code: offer.offerCode,
            amount_minor: offer.checkoutAmountMinor ?? offer.amountMinor,
            displayed_amount_minor: offer.amountMinor, currency: offer.currency,
          } : {}),
        },
      }),
    }).catch(() => {});
  } catch { /* Navigation works even when analytics is unavailable. */ }
}
